import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'orgEntityId',
                },
                'ent:!org:!div',
              ],
            },
            'Department',
          ],
          [
            {
              '=': [
                {
                  '@$': 'orgEntityIdSegment',
                },
                'ent:!org:!div',
              ],
            },
            'Department',
          ],
          'Division',
        ],
      },
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'organizations',
                },
              },
              subqueries: {
                organizations: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdc',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityId',
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityIdSegment',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projects',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'rooms',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'asf',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2024',
                      },
                    },
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          asf: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          tdc: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          idcr: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcr',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          mtdc: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          projects: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'projects',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          totalSqft: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          tdcDensity: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          idcrDensity: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcr',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          mtdcDensity: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          utilization: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          awardFunding: {
                            '{}': {
                              value: {
                                '+': {
                                  '@': 'organizationAwards',
                                },
                              },
                            },
                          },
                          collaborations: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'collaboration',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          effectiveRecovery: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'idcr',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgEntityIdSegment',
                                  },
                                },
                                'ent:!org:!div',
                              ],
                            },
                            null,
                          ],
                          {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          segmentId: 'org',
                                          variables: {
                                            if: [
                                              [
                                                {
                                                  '=': [
                                                    {
                                                      '``': {
                                                        '@$': 'piRecordId',
                                                      },
                                                    },
                                                    null,
                                                  ],
                                                },
                                                {
                                                  '{}': {
                                                    orgRecordId: {
                                                      '@.': '!id',
                                                    },
                                                    orgEntityIdSegment: {
                                                      '@_': 'id',
                                                    },
                                                  },
                                                },
                                              ],
                                              {
                                                '{}': {
                                                  piRecordId: {
                                                    '``': {
                                                      '@$': 'piRecordId',
                                                    },
                                                  },
                                                  orgRecordId: {
                                                    '@.': '!id',
                                                  },
                                                  orgEntityIdSegment: {
                                                    '@_': 'id',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              orgEntityId: {
                                                '@_': 'id',
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      using: 'orgSpace',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': {
                                  '``': {
                                    '@$': 'spaceEntityId',
                                  },
                                },
                              },
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@.': '!sqft',
                              },
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '*': [
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'value',
                                              ],
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'allowable',
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '{}': {
                              value: {
                                '@.': '!weight',
                              },
                              allowable: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '@': 'funcIdCat',
                                        },
                                        null,
                                      ],
                                    },
                                    1,
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    orgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      filter: {
                        and: [
                          {
                            not: {
                              '=': [
                                {
                                  '@': 'projectPiAssignments',
                                },
                                null,
                              ],
                            },
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'projects',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': '!id',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'projects',
                                          },
                                        },
                                      },
                                      'ent:!projects:!proj',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '{}': {
                          tdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          idcr: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcrAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          collaboration: {
                            if: [
                              [
                                {
                                  '>': [
                                    {
                                      '#': {
                                        uniq: {
                                          '@': 'projectPiDepartments',
                                        },
                                      },
                                    },
                                    1,
                                  ],
                                },
                                1,
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                '@.': '!amount',
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@.': [
                                            '!acct',
                                            {
                                              ref: {
                                                entity: '!acct',
                                              },
                                            },
                                          ],
                                        },
                                        '?7631013',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '@': 'isInMtdc',
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          filter: {
                            and: [
                              {
                                not: {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'piRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  {
                                    '@.': [
                                      '!pi',
                                      {
                                        ref: {
                                          entity: '!employee',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                        projectPiDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                          selection: {
                            '@': 'piDept',
                          },
                          subqueries: {
                            piDept: {
                              ref: {
                                attr: 'attr:ent#!proj_pis#!entry:!pi',
                              },
                              target: 'ent:!personnel:!employee',
                              selection: {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: '!dept',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    organizationAwards: {
                      ref: {
                        attr: 'attr:ent#!awards#!award:!org',
                        inherit: '-',
                      },
                      target: 'ent:!awards:!award',
                      selection: {
                        '@.': '!budget',
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdc',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdcDensity',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcDensityMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@_': ['parent', 'id'],
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'orgEntityId',
                              },
                            },
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@_': ['parent', 'id'],
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'orgEntityIdSegment',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projects',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    not: {
                      '=': [
                        {
                          '@': 'rooms',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'asf',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'asfMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'effectiveRecovery',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'effectiveRecoveryMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              period: {
                $range: {
                  end: {
                    $date: '12/31/2024',
                  },
                  start: {
                    $date: '1/1/2024',
                  },
                },
              },
              target: 'dim::!org',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcr',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      idcrDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcr',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      awardFunding: {
                        '{}': {
                          value: {
                            '+': {
                              '@': 'organizationAwards',
                            },
                          },
                        },
                      },
                      collaborations: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'collaboration',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcr',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'orgEntityIdSegment',
                              },
                            },
                            'ent:!org:!div',
                          ],
                        },
                        null,
                      ],
                      {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      segmentId: 'org',
                                      variables: {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'piRecordId',
                                                  },
                                                },
                                                null,
                                              ],
                                            },
                                            {
                                              '{}': {
                                                orgRecordId: {
                                                  '@.': '!id',
                                                },
                                                orgEntityIdSegment: {
                                                  '@_': 'id',
                                                },
                                              },
                                            },
                                          ],
                                          {
                                            '{}': {
                                              piRecordId: {
                                                '``': {
                                                  '@$': 'piRecordId',
                                                },
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                              orgEntityIdSegment: {
                                                '@_': 'id',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          orgEntityId: {
                                            '@_': 'id',
                                          },
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                rooms: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!space',
                  },
                  using: 'orgSpace',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'spaceRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'spaceEntityId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': {
                              '``': {
                                '@$': 'spaceEntityId',
                              },
                            },
                          },
                          {
                            '``': {
                              '@$': 'spaceRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '{}': {
                      asf: {
                        '*': [
                          {
                            '@.': '!sqft',
                          },
                          {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '*': [
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'allowable',
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'value',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                      sqft: {
                        '@.': '!sqft',
                      },
                    },
                  },
                  subqueries: {
                    weights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '!=': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '{}': {
                          value: {
                            '@.': '!weight',
                          },
                          allowable: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '@': 'funcIdCat',
                                    },
                                    null,
                                  ],
                                },
                                1,
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        funcIdCat: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!func_space',
                          },
                          target: 'ent:!func_space:!func',
                          selection: {
                            '@.': [
                              '!func_idc',
                              {
                                ref: {
                                  entity: '!cat',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                orgSpace: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!org',
                    inherit: '-',
                  },
                  target: 'ent:!org_space:!entry',
                },
                projects: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!org',
                    inherit: '-',
                  },
                  filter: {
                    and: [
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projectPiAssignments',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'projects',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!id',
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'projects',
                                      },
                                    },
                                  },
                                  'ent:!projects:!proj',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '{}': {
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      idcr: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'idcrAmount',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      collaboration: {
                        if: [
                          [
                            {
                              '>': [
                                {
                                  '#': {
                                    uniq: {
                                      '@': 'projectPiDepartments',
                                    },
                                  },
                                },
                                1,
                              ],
                            },
                            1,
                          ],
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    projectGlExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          tdcAmount: {
                            '@.': '!amount',
                          },
                          idcrAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!acct',
                                        {
                                          ref: {
                                            entity: '!acct',
                                          },
                                        },
                                      ],
                                    },
                                    '?7631013',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '@': 'isInMtdc',
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      filter: {
                        and: [
                          {
                            not: {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'piRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': [
                                  '!pi',
                                  {
                                    ref: {
                                      entity: '!employee',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    projectPiDepartments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                      selection: {
                        '@': 'piDept',
                      },
                      subqueries: {
                        piDept: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!pi',
                          },
                          target: 'ent:!personnel:!employee',
                          selection: {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: '!dept',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                organizationAwards: {
                  ref: {
                    attr: 'attr:ent#!awards#!award:!org',
                    inherit: '-',
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!budget',
                  },
                },
              },
            },
          },
          columns: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!org#!dept:!code',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!org#!dept:!name',
                        },
                      },
                    },
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'spaceRecordId',
                        },
                        null,
                      ],
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            id: 'awardFunding',
                            direct: {
                              '{}': {
                                name: 'Award Funding',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdc',
                            direct: {
                              '{}': {
                                name: 'TDC',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdcDensity',
                            direct: {
                              '{}': {
                                name: 'TDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdc',
                            direct: {
                              '{}': {
                                name: 'MTDC',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'idcr',
                            direct: {
                              '{}': {
                                name: 'IDC-R',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'idcrDensity',
                            direct: {
                              '{}': {
                                name: 'IDC-R Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'effectiveRecovery',
                            direct: {
                              '{}': {
                                name: 'Effective Recovery',
                                type: 'PERCENT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'asf',
                            direct: {
                              '{}': {
                                name: 'ASF',
                                type: 'INT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'projects',
                            direct: {
                              '{}': {
                                name: 'Projects',
                                type: 'INT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'collaborations',
                            direct: {
                              '{}': {
                                name: 'Collaborations',
                                type: 'INT',
                              },
                            },
                          },
                        },
                      ],
                    },
                  ],
                  {
                    '[]': [
                      {
                        '{}': {
                          id: 'asf',
                          direct: {
                            '{}': {
                              name: 'ASF',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'totalSqft',
                          direct: {
                            '{}': {
                              name: 'Total Area',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'utilization',
                          direct: {
                            '{}': {
                              name: 'Utilization',
                              type: 'PERCENT',
                            },
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      idcr: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcr',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projects',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'totalSqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      idcrDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcrDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'utilization',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      awardFunding: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'awardFunding',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      collaborations: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'collaborations',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      effectiveRecovery: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdc',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'mtdc',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'mtdcDensity',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityId',
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityIdSegment',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projects',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'rooms',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'asf',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'asf',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'effectiveRecovery',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2024',
                      },
                    },
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      asf: {
                        '+': {
                          '->': [
                            {
                              '@': 'rooms',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'asf',
                              ],
                            },
                          ],
                        },
                      },
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdc',
                              ],
                            },
                          ],
                        },
                      },
                      idcr: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'idcr',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdc',
                              ],
                            },
                          ],
                        },
                      },
                      onClick: {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      orgEntityId: {
                                        '@_': 'id',
                                      },
                                      orgRecordId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                },
                              },
                              operation: 'ui.set.variables',
                            },
                          },
                        },
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projects',
                            },
                          },
                          0,
                        ],
                      },
                      totalSqft: {
                        '+': {
                          '->': [
                            {
                              '@': 'rooms',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'sqft',
                              ],
                            },
                          ],
                        },
                      },
                      tdcDensity: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                      idcrDensity: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcr',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                      mtdcDensity: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                      utilization: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                      awardFunding: {
                        '+': {
                          '@': 'organizationAwards',
                        },
                      },
                      collaborations: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'collaboration',
                              ],
                            },
                          ],
                        },
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              orgEntityId: {
                                                '@_': 'id',
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                      effectiveRecovery: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcr',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'projects',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      using: 'orgSpace',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': {
                                  '``': {
                                    '@$': 'spaceEntityId',
                                  },
                                },
                              },
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@.': '!sqft',
                              },
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '*': [
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'value',
                                              ],
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'allowable',
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '{}': {
                              value: {
                                '@.': '!weight',
                              },
                              allowable: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '@': 'funcIdCat',
                                        },
                                        null,
                                      ],
                                    },
                                    1,
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    orgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      filter: {
                        not: {
                          '=': [
                            {
                              '@': 'projectPiAssignments',
                            },
                            null,
                          ],
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '{}': {
                          tdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          idcr: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'idcrAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          collaboration: {
                            if: [
                              [
                                {
                                  '>': [
                                    {
                                      '#': {
                                        uniq: {
                                          '@': 'projectPiDepartments',
                                        },
                                      },
                                    },
                                    1,
                                  ],
                                },
                                1,
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                '@.': '!amount',
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@.': [
                                            '!acct',
                                            {
                                              ref: {
                                                entity: '!acct',
                                              },
                                            },
                                          ],
                                        },
                                        '?7631013',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '@': 'isInMtdc',
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          filter: {
                            and: [
                              {
                                not: {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'piRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  {
                                    '@.': [
                                      '!pi',
                                      {
                                        ref: {
                                          entity: '!employee',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                        projectPiDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                          selection: {
                            '@': 'piDept',
                          },
                          subqueries: {
                            piDept: {
                              ref: {
                                attr: 'attr:ent#!proj_pis#!entry:!pi',
                              },
                              target: 'ent:!personnel:!employee',
                              selection: {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: '!dept',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    organizationAwards: {
                      ref: {
                        attr: 'attr:ent#!awards#!award:!org',
                        inherit: '-',
                      },
                      target: 'ent:!awards:!award',
                      selection: {
                        '@.': '!budget',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    orgLevel: 'Division',
  },
}
